import React from 'react';
import Button from '../shared/Button';

const CTASection = () => {
  return (
    <section className="py-16 bg-gray-900 text-white">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Experience Premium Storage Solutions?</h2>
        <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
          Join thousands of satisfied customers who trust Storage Sprint with their storage and delivery needs.
        </p>
        <Button
          to="contact"
          primary
          className="px-8 py-4 text-lg inline-block"
        >
          Get Started Today <i className="fas fa-arrow-right ml-2"></i>
        </Button>
      </div>
    </section>
  );
};

export default CTASection;